export default {
  en: {
    serviceRequest: "Service request",
    declareIncident: "Declare an incident",
    other: "other",
    others: "others",
    firstName: "First Name",
    newAppText: "A new version of the application is available, please click to refresh.",
    emailPro: "Professional email address",
    refresh: "Refresh",
    lastName: "Last Name",
    incidentConfirmation:
      "You are about to leave the application to declare an incident. Do you want to continue?",
    PENDING: "Pending",
    IN_PROGRESS: "In Progress",
    CANCELED: "Canceled",
    ARCHIVED: "Archived",
    COMPLETED: "Completed",
    ACTION_NEEDED: "Action",
    ACTIVITY_MONITORING: "Activity monitoring",
    ISO17029_COMPLIANCE_AUDIT: "ISO 17029 Compliance Audit",
    INTERNAL_AUDIT_REPORT: "Internal Audit Report",
    SCORED_AUDIT_REPORT: "Scored Audit Report",
    TECHNICAL_AUDIT_SUMMARY: "Technical Audit Summary",
    errorOccurred: "An error occurred, please try again later",
    errorOccurredLoadingData: "An error occurred while loading data, please try again",
    errorOccurredSavingData: "An error occurred while saving data, please try again",
    dataUpdatedSuccessfully: "Your changes have been saved successfully",
    audit: {
      AuditTypeSelectionStep: "Audit type selection",
      AuditInformationsStep: "Audit information",
      AuditQuestionnaireStep: "Audit questionnaire",
      AuditResumeStep: "Audit summary",
      previousStep: "Previous step",
      start: "Start",
      next: "Next",
      submit: "Submit",
      toHome: "Back to home",
      continue: "Continue",
      saveAndQuit: "Save and quit",
      generationInProgress:
        "The report generation is in progress. You will be notified when it is ready",
      generationStarted: "The report generation has started. You will be notified when it is ready",
      generationReportError: "An error occurred during report generation",
      finishQuestionnaireError: "The questionnaire could not be submitted, please try again",
      reportReady: "The report is ready. It should be downloaded automatically",
      downloadDocumentError: "An error occurred while downloading the document",
      generateDocument: "Save and generate document",
      downloadDocument: "Download document",
      auditTypeFilter: "Type",
      evaluatorFilter: "Evaluator",
      caseNumberFilter: "Case number",
      statusFilter: "Status",
      evaluatedAgencyFilter: "Evaluated agency",
      createdAtFilter: "Creation date",
      missionCodeFilter: "Mission code",
      evaluationDateFilter: "Evaluation date",
      programmationDateFilter: "Programming date",
    },
    auditQuestionnaire: {
      activitySurveillance: "Activity monitoring",
      selectAnswer: "Select the rating",
      comment: "Comment",
      commentRequired: "Comment (required)",
      questionCompleted: "Answered",
      questionNotCompleted: "Not answered",
      questionNotFullyCompleted: "Incomplet",
      auditAlreadyProcessed: "The audit has already been validated, you cannot modify the answers",
    },
    auditResume: {
      title: "Activity monitoring is complete!",
      description: "You can take a break... or move on",
      information: "Information",
      reviewer: "Reviewer",
      surveyedAgency: "Surveyed Agency",
      activityNature: "Activity Nature",
      domain: "Domain",
      otherMissionCode: "Other Mission Codes",
      agencyPole: "Agency Pole",
      evaluatedPersons: "Evaluated Persons",
      missionCode: "Mission Code",
      caseAndAgency: "Case and Agency",
      caseNumber: "Case Number",
      descriptionAgency: "Affaire Description",
      creationDate: "Creation Date",
      programationDate: "Programming Date",
      evaluationDate: "Evaluation Date",
      missionChoices: "Mission Choice Criteria",
      caseReference: "Case Reference",
      interventionReference: "Intervention Reference",
      caseDescription: "Case Description",
      conforme: "Conforme",
      toImprove: "À améliorer",
      insuffisant: "Insuffisant - NC",
      scoreTotal: "Score total",
      auditStatus: "Audit Status",
      reportReference: "Report Reference",
      detailsTitle: "Results Details",
      pointFort: "Point fort",
      questionsDetails: "Questions Details",
      commentPlaceholder: "Enter a comment...",
      comment: "Comment",
      actionPlan: "Actions Plan",
      correctiveActions: "Corrective Actions",
      completedActions: "Completed Actions",
    },
    auditHistoricalResume: {
      title: "Audit Historical Resume",
      description:
        "You are currently in an activity monitoring imported from Syriel. You cannot modify it but you can download the report containing the results.",
      downloadReport: "Download the report",
    },
    questionStatus: {
      INSUFFICIENT: "Insufficient thematic - NC",
      COMPLIANT: "Compliant thematic",
      TO_IMPROVE: "Non-compliant thematic",
      STRENGTH: "Strength thematic",
      label: {
        INSUFFICIENT: "Not conform",
        COMPLIANT: "Compliant",
        STRENGTH: "Strength",
        TO_IMPROVE: "To improve",
      },
      comment: "Comment",
    },
    task: {
      taskPending: "Task awaiting execution",
      downloadReport: "Download the report",
      taskSuccess: "Task completed successfully",
      taskInfo: "Task in progress",
      taskCanceled: "Task canceled",
      taskError: "The task has failed, please try again later",
      reportGeneration: "Report generation",
      noTask: "No ongoing task",
      tasks: "Tasks",
    },
  },
  fr: {
    serviceRequest: "Demande de service",
    declareIncident: "Déclarer un incident",
    others: "autres",
    other: "autre",
    refresh: "Rafraîchir",
    firstName: "Prénom",
    lastName: "Nom",
    newAppText:
      "Une nouvelle version de l'application est disponible, veuillez cliquer pour rafraîchir.",
    emailPro: "Adresse e-mail pro.",
    incidentConfirmation:
      "Attention, un 'Incident' est un bug logiciel qui est bloquant pour la production des intervenants",
    PENDING: "En attente",
    IN_PROGRESS: "En cours",
    ARCHIVED: "Archivé",
    CANCELED: "Annulé",
    ACTION_NEEDED: "Action",
    COMPLETED: "Terminé",
    ACTIVITY_MONITORING: "Surveillance d'activité",
    INTERNAL_AUDIT_REPORT: "Rapport d'audit interne",
    ISO17029_COMPLIANCE_AUDIT: "Audit de conformité ISO 17029",
    TECHNICAL_AUDIT_SUMMARY: "Résumé d'audit technique",
    SCORED_AUDIT_REPORT: "Rapport d'audit noté",
    errorOccurred: "Une erreur est survenue, veuillez réessayer",
    errorOccurredLoadingData:
      "Une erreur est survenue lors du chargement des données, veuillez réessayer",
    errorOccurredSavingData:
      "Une erreur est survenue lors de la sauvegarde des données, veuillez réessayer",
    dataUpdatedSuccessfully: "Vos modifications ont bien été enregistrées",
    audit: {
      AuditTypeSelectionStep: "Sélection du type d'audit",
      AuditInformationsStep: "Informations sur l'audit",
      AuditQuestionnaireStep: "Questionnaire d'audit",
      AuditResumeStep: "Résumé de l'audit",
      previousStep: "Étape précédente",
      next: "Suivant",
      start: "Commencer",
      submit: "Soumettre",
      continue: "Continuer",
      toHome: "Revenir à l'accueil",
      saveAndQuit: "Enregistrer et quitter",
      generationStarted:
        "La génération du rapport a démarré. Vous serez notifié lorsqu'il sera prêt",
      generationInProgress:
        "La génération du rapport est en cours. Vous serez notifié lorsqu'il sera prêt",
      generationReportError: "Une erreur est survenue lors de la génération du rapport",
      finishQuestionnaireError: "Le questionnaire n'a pas pu être soumis, veuillez réessayer",
      reportReady: "Le document est prêt. Il devrait être téléchargé automatiquement",
      downloadDocumentError: "Une erreur est survenue lors du téléchargement du document",
      downloadDocument: "Télécharger le rapport",
      generateDocument: "Enregistrer et générer le rapport",
      auditTypeFilter: "Type",
      caseNumberFilter: "N° Affaire",
      evaluatorFilter: "Évaluateur",
      statusFilter: "Statut",
      evaluatedAgencyFilter: "Agence évaluée",
      missionCodeFilter: "Code de mission",
      createdAtFilter: "Date de création",
      programmationDateFilter: "Date de programmation",
      evaluationDateFilter: "Date d'évaluation",
    },
    auditQuestionnaire: {
      activitySurveillance: "Surveillance d'activité",
      selectAnswer: "Sélectionnez la notation",
      comment: "Commentaire",
      commentRequired: "Commentaire (obligatoire)",
      questionCompleted: "Renseigné",
      questionNotCompleted: "Non renseigné",
      questionNotFullyCompleted: "Incomplet",
      auditAlreadyProcessed: "L'audit a déjà été validé, vous ne pouvez pas modifier les réponses",
    },
    auditResume: {
      title: "La surveillance d'activité est terminée !",
      description: "Vous pouvez faire une pause… ou passer à la suite",
      surveyedAgency: "Agence concernée",
      information: "Informations",
      reviewer: "Évaluateur",
      agencyPole: "Pôle",
      evaluatedPersons: "Collaborateurs concernés",
      missionCode: "Code mission",
      activityNature: "Nature activité",
      domain: "Domaine",
      otherMissionCode: "Autres codes missions",
      caseAndAgency: "Affaire et agence",
      caseNumber: "Description de la mission",
      descriptionAgency: "Description affaire",
      creationDate: "Date création",
      programationDate: "Date programmation",
      evaluationDate: "Date de fin d'évaluation",
      missionChoices: "Critères choix mission",
      caseReference: "Référence affaire",
      caseDescription: "Description de l'Affaire",
      reportReference: "Type d’intervention",
      interventionReference: "Référence intervention",
      detailsTitle: "Détails des résultats",
      pointFort: "Point fort",
      conforme: "Conforme",
      toImprove: "À améliorer",
      insuffisant: "Insuffisant - NC",
      scoreTotal: "Score total",
      auditStatus: "Statut audit",
      questionsDetails: "Détails des questions",
      comment: "Commentaire",
      commentPlaceholder: "Saisissez un commentaire...",
      actionPlan: "Plan d'actions",
      correctiveActions: "Actions correctives / curatives",
      completedActions: "Actions réalisées",
    },
    auditHistoricalResume: {
      title: "Audit importé de Syriel",
      description:
        "Vous êtes actuellement dans une surveillance d’activité importée de Syriel. Vous ne pouvez pas la modifier mais vous pouvez télécharger le rapport contenant les résultats.",
      downloadReport: "Télécharger l'audit",
    },
    questionStatus: {
      INSUFFICIENT: "Thématique insuffisante - NC",
      TO_IMPROVE: "Thématique à améliorer",
      COMPLIANT: "Thématique conforme",
      STRENGTH: "Thématique point fort",
      label: {
        INSUFFICIENT: "Non conforme",
        TO_IMPROVE: "À améliorer",
        COMPLIANT: "Conforme",
        STRENGTH: "Point fort",
      },
      comment: "Commentaire",
    },
    task: {
      downloadReport: "Télécharger le rapport",
      taskPending: "Tâche en attente d'exécution",
      taskSuccess: "Tâche terminée avec succès",
      taskError: "La tâche a échoué, veuillez réessayer plus tard",
      taskInfo: "Tâche en cours",
      taskCanceled: "Tâche annulée",
      reportGeneration: "Génération du rapport",
      tasks: "Tâches",
      noTask: "Aucune tâche en cours",
    },
  },
};
